import React, { FC } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from 'components';
import { smMobile } from 'styles/breakpoints';

const ButtonStyled = styled(PrimaryButton)`
  min-width: 15rem;
  width: 100%;
  max-width: 28.75rem;
  height: 3rem;

  @media ${smMobile} {
  }
`;

const Button: FC = ({ children = 'Start Now', ...props }) => (
  <ButtonStyled {...props}>{children}</ButtonStyled>
);

export default Button;
